
<template>
  <div class="parent_div">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="pageList"
    />
    <div class="container">
      <div id="content">
        <div>
          <section>
            <h2>注文完了</h2>
            <div>
              ご注文ありがとうございました。注文完了メールを自動送信しました。
            </div>
          </section>
          <div class="detail_btn2 btn_pos_center" @click="goTop()">トップページへ 〉〉</div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="complete_content">
    <dd-header
      :headerSubContentType=1
      :headerTelContentType=1
    />
    <div class="container">
      <dd-sitemap
        :pageKey="pageKey"
        :pageList="pageList"
      />
      <div id="content">
        <div class="title">
          <h2>注文完了</h2>
        </div>
        <div class="thanks_message">
          <ul>
            <li>ご注文ありがとうございました。</li>
            <li>注文完了メールを自動送信しました。</li>
            <li>
              <a @click="goTop">TOPへ戻る</a>
            </li>
          </ul>
        </div>
        <div class="logo">
          <h2><img :src="getImage('common/logo.png')" alt="ミリスタイル"></h2>
          <div>My size, My lifestyle.</div>
        </div>
      </div>
    </div>
  </div> -->
</template>
<script>

import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import SiteMap from '../components/common/DcSiteMap'
import LoginForm from '../components/login/DcLoginForm'

export default {
  name: 'orderComplete',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    'dd-login': LoginForm
  },
  data () {
    return {
      pageKey: 'orderComp',
      pageList: []
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({
        name: 'DcTop'
      })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created () {
    let orderForm = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    if (!orderForm || Object.keys(orderForm) <= 0) {
      this.pageList = App.getLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    } else {
      this.pageList = orderForm.pageList
      App.setLocalStorage(DC_STORAGE_KEY.PAGE_LIST, this.pageList)
    }
    App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    App.removeLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
    App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
    App.removeLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE)

    App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcOrderComplete.vue